import React from "react";
import { Box, Typography, Link, Stack, alpha, useTheme } from "@mui/material";
import { Verified } from "@mui/icons-material";

export default function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        p: 4,
        textAlign: "center",
        mt: "auto",
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
        backgroundColor: alpha("#fff", 0.5),
        backdropFilter: "blur(10px)",
      }}
    >
      <Stack spacing={1} alignItems="center">
        {/* SİSTEM BİLGİSİ VE TELİF */}
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: 500,
            letterSpacing: 0.8,
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          © 2026 <strong>HTC </strong> | Arazi Takip ve Analiz Sistemi. Tüm
          hakları saklıdır.
        </Typography>

        {/* GELİŞTİRİCİ İMZASI */}
        <Typography
          variant="caption"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          Designed & Developed by{" "}
          <Link
            href="https://scalavisione.com.tr"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "primary.main",
              textDecoration: "none",
              fontWeight: 800,
              borderBottom: "2px solid",
              borderColor: alpha(theme.palette.primary.main, 0.2),
              pb: 0.1,
              ml: 0.5,
              transition: "all 0.3s ease",
              "&:hover": {
                color: "primary.dark",
                borderColor: "primary.dark",
                transform: "translateY(-1px)",
              },
            }}
          >
            <Verified sx={{ fontSize: 14 }} />
            SCALAVISIONE
          </Link>
        </Typography>
      </Stack>
    </Box>
  );
}
